import {fetch as fetchRaw} from '@lib/fetch'
import {riskAnalysis} from '../services'
import {getDefinedUrlSearchParams} from '@lib/util'

const fetch = (url, ...args) => fetchRaw([riskAnalysis.url, url], ...args)

export function riskAnalysisGetRisks(queryParams) {
  return fetch(`/v2/risks?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function riskAnalysisAdminUpdateRisk(id, body) {
  return fetch(`/v2/risks/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function riskAnalysisAdminCreateRisk(body) {
  return fetch('/v2/risks', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getRiskGross(queryParams) {
  return fetch(`/v2/risk-gross?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function updateRiskGross(id, body) {
  return fetch(`/v2/risk-gross/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function createRiskGross(body) {
  return fetch('/v2/risk-gross', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getRiskAssessments(queryParams) {
  return fetch(`/v2/assessment-blueprints?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskAssessmentBlueprint(id) {
  return fetch(`/v2/assessment-blueprints/${id}`, {
    method: 'GET',
  })
}

export function createRiskAssessment(body) {
  return fetch('/v2/assessment-blueprints', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function updateRiskAssessment(id, body) {
  return fetch(`/v2/assessment-blueprints/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
}

export function getAssessmentFormulas(queryParams) {
  return fetch(`/v2/assessment-formulas?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getAssessment(id) {
  return fetch(`/v2/assessment/${id}`, {
    method: 'GET',
  })
}

export function createAssessment(body) {
  return fetch('/v2/assessment', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function createBulkAssessment(body) {
  return fetch('/v2/assessment/bulk-create', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function createRiskAssessmentFormula(body) {
  return fetch(`/v2/assessment-formulas`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getAssessments(queryParams) {
  return fetch(`/v2/assessment?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getAssessmentHistory(originAssessmentId, queryParams) {
  return fetch(`/v2/assessment/history/${originAssessmentId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskAssessmentFormulas(queryParams) {
  return fetch(`/v2/assessment-formulas?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskAssessmentFormula(id) {
  return fetch(`/v2/assessment-formulas/${id}`, {
    method: 'GET',
  })
}

export function updateRiskAssessmentFormula(id, body) {
  return fetch(`/v2/assessment-formulas/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function recalculateAssessment(ids) {
  return fetch(`/v2/assessment/recalculate`, {
    method: 'POST',
    body: JSON.stringify({
      ids,
    }),
  })
}

export function getRiskLandscapeData(queryParams) {
  return fetch(`/v2/risk-landscape?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskLandscapeCountryData(countryCode) {
  return fetch(`/v2/risk-landscape/${countryCode}`, {
    method: 'GET',
  })
}

export function copyAssessmentFormula(assessmentFormulaIds) {
  return fetch(`/v2/assessment-formulas/copy`, {
    method: 'POST',
    body: JSON.stringify(assessmentFormulaIds),
  })
}

export function getAssessmentFormulaStatistics(originFormulaId) {
  return fetch(`/v2/assessment-formulas/${originFormulaId}/statistics`, {
    method: 'GET',
  })
}

export function createManualMitigation(body) {
  return fetch(`/v2/manual-mitigations`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getRemarks(assessmentId, queryParams) {
  return fetch(`/v2/manual-mitigations/assessments/${assessmentId}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function listMitigations(queryParams) {
  return fetch(`/v2/manual-mitigations?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getStandardAssessmentScore(id) {
  return fetch(`/v3/companies/${id}/assessments/standard`, {
    method: 'GET',
  })
}

export function createRiskAssessmentFormulaV3(body) {
  return fetch(`/v3/rule-templates`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getRiskAssessmentFormulaV3(id) {
  return fetch(`/v3/rule-templates/${id}`, {
    method: 'GET',
  })
}

export function updateRiskAssessmentFormulaV3(id, body) {
  return fetch(`/v3/rule-templates/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
}

export function getRiskAssessmentMetricsV3() {
  return fetch(`/v3/metrics`, {
    method: 'GET',
  })
}

export function getRiskAssessmentDataPointsV3() {
  return fetch(`/v3/datapoints`, {
    method: 'GET',
  })
}

export function getRiskAssessmentCertificationsV3(queryParams) {
  return fetch(`/v3/certifications?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskAssessmentAuditTypesV3(queryParams) {
  return fetch(`/v3/audit-types?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getRiskAssessmentAuditTypesWithFindingsV3(queryParams) {
  return fetch(`/v3/audit-types?withFindings=true${queryParams ? '&' + getDefinedUrlSearchParams(queryParams) : ''}`, {
    method: 'GET',
  })
}

export function getRiskAssessmentRiskFactorsV3() {
  return fetch(`/v3/risks?count=30`, {
    method: 'GET',
  })
}

export function getRiskAssessmentRiskFactorsImpactAreaV3(queryParams) {
  return fetch(`/v3/impact-areas/risks?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getFacilityProcessesV3(params) {
  return fetch(`/v3/facility-processes?${getDefinedUrlSearchParams(params)}`, {
    method: 'GET',
  })
}

export function getProductTypesV3(params) {
  return fetch(`/v3/product-categories?${getDefinedUrlSearchParams(params)}`, {
    method: 'GET',
  })
}

export function getRiskAssessmentDocumentTypesV3(params) {
  return fetch(`/v3/document-types?${getDefinedUrlSearchParams(params)}`, {
    method: 'GET',
  })
}
export function copyAssessmentFormulaV3(assessmentFormulaIds) {
  return fetch(`/v2/rule-templates/copy`, {
    method: 'POST',
    body: JSON.stringify(assessmentFormulaIds),
  })
}

export function getRelationshipTypesV3(params) {
  return fetch(`/v3/relationship-types?${getDefinedUrlSearchParams(params)}`, {
    method: 'GET',
  })
}
